export default "__VITE_ASSET__7a1fee42__"